module.exports = __webpack_public_path__ + "static/img/9.d72abae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg/9.jpg
// module id = nBDd
// module chunks = 1